import { sortOptions } from '../../index'

/**
 * Return a list of sort options with a defined label-value-mapping as well as the currently active option.
 *
 * @param {Object} queryParams - An object containing query parameters from
 *   which the currently active sorting option is derived. The first sorting
 *   option is used as a fallback.
 * @param {func} t - A function to transform the option label, usually the
 *   translation function from the `useTranslation()` hook
 * @returns {[(*&{label: *, value: *})[],*&{label: *, value: *}]}
 */
const getSortOptions = (queryParams = {}, t = (s) => s) => {
  const sortBy = queryParams.sortBy ?? sortOptions[0].sortBy
  const order = queryParams.order ?? sortOptions[0].order

  const options = sortOptions.map((o) => {
    return {
      ...o,
      label: t(o.label),
      value: o.value,
    }
  })

  const selectedOption =
    options.find(
      (option) => option.sortBy === sortBy && option.order === order
    ) || options[0]

  return [options, selectedOption]
}

export default getSortOptions
